import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {TeamManagementService} from '../../../services/api/team-management.service';
import {MySitesService} from '../../../services/my-sites.service';
import {IProductDataAddonModifyMenu} from '../../../types/product.type';

@Component({
  selector: 'mc-sites-confirm-dialog',
  templateUrl: './sites-confirm-dialog.component.html',
  styleUrls: ['./sites-confirm-dialog.component.scss'],
})
export class SitesConfirmDialogComponent implements OnInit {
  sites: string[];
  showedSiteCount = 5;
  constructor(
    public dialogRef: MatDialogRef<SitesConfirmDialogComponent>,
    public teamManagementService: TeamManagementService,
    private sitesService: MySitesService,
    @Inject(MAT_DIALOG_DATA) public data?: {modifyMenuSites: IProductDataAddonModifyMenu['modifyMenuSites']},
  ) {}

  get sitesList() {
    return this.sites.slice(0, this.showedSiteCount).join(', ');
  }

  get showMoreInfo() {
    return this.sites.length > this.showedSiteCount;
  }

  get restCountOfSites() {
    return this.sites.length - this.showedSiteCount;
  }

  ngOnInit() {
    this.sites = this.data?.modifyMenuSites
      ? this.data.modifyMenuSites.map(site => site.host).reverse()
      : this.sitesService.mySitesList;
  }

  confirm() {
    this.dialogRef.close({confirm: true});
  }

  close(): void {
    this.dialogRef.close();
  }
}
